module.exports = __webpack_public_path__ + "media/images/front/pricing_flow/close-88e76eb41dd38c388252e2e3f4f9b587.svg";